// extracted by mini-css-extract-plugin
module.exports = {"thumbnailCellWrap":"TableCells_thumbnailCellWrap__YFPbd"};